import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import history from 'utils/history';

import { Button, FormBody, FormFooter } from 'twyne-new.ui';
import { useUserStore } from "../store";

import UserForm from './UserForm';

class Form extends React.Component {
  state = {
    gender: null,
    active: true,
    adminPainel: true
  };

  componentWillMount() {
    const data = this.props.data;
    if (data) {
      this.setState(data);
    }
  }

  handleValidSubmit = (model) => {
    model.is_admin = true;
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <FormBody>
          <UserForm type='admin' useUserStore={useUserStore} data={this.state} />
          <FormFooter>
            <Button type="submit" color='accent'>Save</Button>
            <Button onClick={() => history.goBack()} variant='ghost'>Cancel</Button>
          </FormFooter>
        </FormBody>
      </Formsy>
    );
  }
}

Form.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any
};

export default Form;
